import { Box, Button } from "@mui/material"
import { LoadingWrapper } from "../../../components/LoadingWrapper"
import { SimpleToolbar, Table } from "../../../components/Table"
import { useQuery, gql } from "@apollo/client"
import { useNavigate, useParams } from "react-router"
import { Note } from "../../../__generated__/graphql"
import { format } from 'date-fns';
import { GridColDef } from "@mui/x-data-grid"
import { useEffect, useState, useMemo } from "react"
import { AddBox, Description, Send } from "@mui/icons-material"
import { useSlideInContext } from "../../../context/SlideInContext"
import { ADD_NOTE, MAKE_A_REFERRAL } from "../../components/SlideIn/contentTypes"
import { useStudentContext } from "../../../context/studentContext"
import { StudentDataType } from "../hooks/useSelectedStudent"
type StudentNoteTableProps = {
    onBack?: () => void
}
export const STUDENT_NOTES_QUERY = gql(`query StudentNotes($studentId:UUID!){
  student(id:$studentId){
    __typename
    id
    firstName
    lastName
    allNotes {
        id
        body
        id
        type
        origin
        sessionNotes{
            session{
                id
                createdAt
            }
        }
        createdAt
        person{
            id
            firstName
            lastName
            role{
                normalizedName}
            }
    }
  }
}
`);

function pascalCaseToHumanReadable(text: string | null | undefined) {
    if (!text) return "";
    return text.replace(/([A-Z])/g, ' $1')
        .replace(/^./, function (str) { return str.toLocaleUpperCase().trim(); })
}
function mapDataToTable(notes: Note) {
    return {
        id: notes.id,
        type: pascalCaseToHumanReadable(notes.type),
        body: notes.body,
        username: `${notes.person?.firstName} ${notes.person?.lastName}`,
        createdAt: format(new Date(notes.createdAt), "MM/dd/yyyy"),
        sessionId: notes.sessionNotes[0]?.session?.id,
        sessionCreatedAt: notes.sessionNotes[0]?.session?.createdAt ? format(new Date(notes.sessionNotes[0]?.session?.createdAt), "MM/dd/yyyy") : "General Note, no session Attached"
        // sessionId: notes.sessionNotes.map(x => x?.session?.id),
        // sessionDate: notes.sessionNotes.map(x => x?.session?.createdAt)
    }
}
export const StudentNoteTable = ({ onBack }: StudentNoteTableProps) => {
    const params = useParams()
    const { changeStudent, studentData } = useStudentContext()
    const { data, loading, error } = useQuery(STUDENT_NOTES_QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: {
            studentId: params.sid
        }
    })

    const { handleContent } = useSlideInContext()
    const navigate = useNavigate()
    const handleAddNote = () => {
        console.log(studentData)
        // changeStudent(studentData)
        handleContent(ADD_NOTE)
    }
    useEffect(() => {
        if (studentData == null && data) {
            console.log("changing the student: ", data)
            // changeStudent(data?.student as StudentDataType)
        }
    }, [studentData, data])

    const [rows, setRows] = useState<any[]>([]);
    useEffect(() => {
        if (!data) return;
        const notes = [...data.student.allNotes].sort(function (a, b) {
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        }).map(x => mapDataToTable(x as any))
        setRows(notes)
    }, [data]);
    const goToReportsPage = () => {
        navigate(`/dashboard/student/${params.sid}/sessions`)
    }
    const columns = useMemo((): GridColDef[] => {
        return [
            {
                field: 'createdAt',
                headerName: 'Date',
                sortable: false,
                resizable: false,
                editable: false,
                disableColumnMenu: true,
                headerAlign: 'center',
                align: 'center',
                width: 120
            },
            {
                field: 'type',
                headerName: 'Note Type',
                sortable: false,
                resizable: false,
                editable: false,
                disableColumnMenu: true,
                headerAlign: 'left',
                align: 'left',
                flex: 1,
                renderCell: (params) => (
                    <div style={{ whiteSpace: 'break-spaces', wordBreak: 'break-word' }}>
                        {params.value}
                    </div>
                ),
            },
            {
                field: 'body',
                headerName: 'Note',
                sortable: false,
                resizable: false,
                editable: false,
                disableColumnMenu: true,
                headerAlign: 'left',
                align: 'left',
                flex: 2
            },
            {
                field: 'username',
                headerName: 'Posted by',
                sortable: false,
                resizable: false,
                editable: false,
                disableColumnMenu: true,
                headerAlign: 'left',
                align: 'left',
                flex: .5
            },
            {
                field: "sessionCreatedAt",
                headerName: "Session Date",
                sortable: true,
                resizable: false,
                editable: false,
                disableColumnMenu: true,
                headerAlign: 'left',
                flex: .5,
                // renderCell: (params) => {
                //     return (
                //         <div>
                //             {/* {params.row.sessionId ?
                //                 <Button onClick={ }>
                //                     {params.row.sessionCreatedAt}
                //                 </Button> :
                //                 <div>
                //                     {params.row.sessionCreatedAt}</div>
                //             } */}


                //         </div>
                //     )
                // }
            }
        ]
    }, []);
    const handleMakeReferral = () => {
        handleContent(MAKE_A_REFERRAL)
    }
    return (
        <LoadingWrapper loading={loading && !data} sx={{ marginTop: 4 }}>
            <Box component="div" sx={{ background: "fff", paddinTop: 1, marginTop: 4, marginBottom: 8 }}>
                <Table loading={loading}
                    renderToolbar={() => {
                        return (
                            <Box component="div" sx={{ paddingBottom: 1 }}>
                                <SimpleToolbar title={`Notes for ${data?.student.firstName} ${data?.student.lastName}`}
                                    onBack={onBack}
                                    rightSlot={() => (
                                        <Box component="div" sx={{ display: "flex", justifyContent: "end", alignContent: "center", flexWrap: "wrap" }}>
                                            <Button color="secondary" variant="text" startIcon={<Description />} onClick={goToReportsPage}>View Reports</Button>
                                            <Button color="secondary" variant="text" startIcon={<AddBox />} onClick={handleAddNote} sx={{ p: [1.5, 3] }}>Add General Note</Button>
                                            <Button color="secondary" variant="text" startIcon={<Send />} onClick={handleMakeReferral} sx={{ p: [1.5, 3] }}>Make Referral</Button>
                                        </Box>
                                    )}
                                />
                            </Box>
                        )
                    }}
                    autoHeight
                    columns={columns}
                    rows={rows}
                    pageSize={10}
                    disableBoxShadow={false}
                />
            </Box>
        </LoadingWrapper>
    )
}